import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private searchTextSubject = new BehaviorSubject<string>('');
  public readonly searchText = this.searchTextSubject.asObservable();

  private searchResultLanguageSubject = new BehaviorSubject<string>('');
  public readonly searchResultLanguage =
    this.searchResultLanguageSubject.asObservable();

  private isSearchingSubject = new BehaviorSubject<boolean>(false);
  public readonly isSearching = this.isSearchingSubject.asObservable();

  setSearchText(searchText: string) {
    this.searchTextSubject.next(searchText);
  }
  setSearchResultLanguage(languageName: string) {
    this.searchResultLanguageSubject.next(languageName);
  }
  setIsSearching(isSearching: boolean) {
    this.isSearchingSubject.next(isSearching);
  }
}
